export default __webpack_public_path__ + "static/media/Icon-menu_layout.6d47edaa.svg";